import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {

  constructor() { }

}
